// ── Escape closes the top popup ──────────────────────────────────────────────
//
// useEscape(handler) — while handler is set, pressing Escape calls it. Every
// popup in the app uses it: Modal (and so every form, detail window and
// Confirm), the dropdown menus, and the few overlays drawn by hand.
//
// ONE AT A TIME, TOP FIRST. Popups register on a stack as they open, so with a
// confirm open over a form, Escape cancels the confirm and leaves the form; a
// second Escape closes the form. A dropdown inside a window closes before the
// window does. Pass null (e.g. useEscape(open ? close : null)) when closed.
//
// Escape is the same as the × / Cancel: nothing is saved.
import { useEffect, useRef } from "react";

const stack = [];
const onKey = e => {
  if (e.key !== "Escape" || e.defaultPrevented || e.isComposing) return;
  const top = stack[stack.length - 1];
  if (!top) return;
  e.preventDefault();
  e.stopPropagation();
  top.fire();
};
if (typeof window !== "undefined" && !window.__aceEscape) {
  window.addEventListener("keydown", onKey);
  window.__aceEscape = true;
}

export const useEscape = handler => {
  const ref = useRef(handler);
  ref.current = handler;
  const active = !!handler;
  useEffect(() => {
    if (!active) return undefined;
    const entry = { fire: () => { if (ref.current) ref.current(); } };
    stack.push(entry);
    return () => { const i = stack.lastIndexOf(entry); if (i >= 0) stack.splice(i, 1); };
  }, [active]);
};
